import { getToken } from "./authService";
import { API_BASE_URL } from "../config/apiConfig";

export async function apiFetch(url, options = {}) {
  const token = getToken();
  
  // Si la URL no comienza con http, agregarle la base URL
  const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;

  const headers = {
    Accept: "application/json",
    ...(options.headers || {}),
  };

  // ❗ NO setear Content-Type si es FormData
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(fullUrl, {
    ...options,
    headers,
  });

  return response;
}

export async function sendContactForm(formData) {
  const response = await apiFetch('/contact', {
    method: 'POST',
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    throw new Error('Error al enviar el formulario de contacto');
  }

  return response.json();
}

export { API_BASE_URL };